<script setup lang="ts">
import PanelGroup from '../PanelGroup.vue'
import { BRAND_APP_TABS } from '../../lib/brandAppContract'
import { COMING_SOON_SCREENS, HOME_LAYOUT_SECTION, SCREEN_SECTIONS } from '../../lib/brandAppSections'
import useBrandAppConfig from '../../composables/useBrandAppConfig'
import OrderedSubsetList from '../OrderedSubsetList.vue'

defineProps<{ title?: string }>()

const { tabs, tabOrder, setTabs, setTabOrder, features, hasLoyalty } = useBrandAppConfig()

const { t } = useI18n()

const items = computed(() =>
  BRAND_APP_TABS.map((tab) => ({
    id: tab.id,
    label: tab.label,
    icon: tab.id === 'home' ? HOME_LAYOUT_SECTION.icon : SCREEN_SECTIONS[tab.id].icon
  }))
)
</script>

<template>
  <PanelGroup :title="title">
    <div class="flex flex-col gap-5">
      <OrderedSubsetList
        :items="items"
        :model-value="tabs"
        :order="tabOrder"
        :disabled-ids="COMING_SOON_SCREENS"
        :disabled-hint="t('pages.loyaltySupports.webapp.editor.screens.comingSoon')"
        @update:model-value="setTabs"
        @update:order="setTabOrder"
      />

      <div v-if="!features.showTabBar || !hasLoyalty" class="flex flex-col gap-2">
        <BaseTip
          v-if="!features.showTabBar"
          severity="secondary"
          :text="t('pages.loyaltySupports.webapp.editor.structure.navigation.singleTab')"
        />
        <BaseTip
          v-if="!hasLoyalty"
          severity="secondary"
          :text="t('pages.loyaltySupports.webapp.editor.structure.navigation.noLoyalty')"
        />
      </div>
    </div>
  </PanelGroup>
</template>
